import {fetch} from "utils/dataAccess";

export async function list(params = '') {
    const response = await fetch('/shipments?' + params);

    if (!response.ok) throw new Error('Failed to retrieve shipments');

    const data = await response.json();

    return data;
}
